export const DYNAMIC_REQUEST_CREATE_PATH = "/dynamic-requests/:type/create";
export const DYNAMIC_REQUEST_EDIT_PATH = "/dynamic-requests/:type/:id";
